import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import Popover from "@mui/material/Popover";
import PanToolAltIcon from "@mui/icons-material/PanToolAlt";

import { common_axios } from "../../../../App";
import { toast } from "react-toastify";

import {
  Backdrop,
  Button,
  IconButton,
  InputLabel,
  TextField,
  Tooltip,
} from "@mui/material";
import Loader from "../../../../components/Loader";

import { dateFormatter } from "../../../../helper/helper";
import ReceiptIcon from "@mui/icons-material/Receipt";

import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useSelector } from "react-redux";
import DateRangePickerr from "../../Dashboard/DateRangePicker";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import DownloadIcon from "@mui/icons-material/Download";
import { CSVLink, CSVDownload } from "react-csv";
import InfoIcon from "@mui/icons-material/Info";
import moment from "moment";
import { DownloadExcel } from "react-excel-export";
import Swal from "sweetalert2";

export default function ScheduledVoiceCampaign() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  // const [downloadeddata, setDownloadedData] = useState([]);
  const [totalPage, setTotalPage] = useState();
  const [totalPageCount, settotalPageCount] = useState(0);
  const [totalPageCountShow, settotalPageCountShow] = useState(1);
  const [count, setCount] = useState({
    approvedCount: 0,
    pendingCount: 7,
    rejectedCount: 0,
  });

  //
  const [anchorEll, setAnchorEll] = React.useState(null);

  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [date, setDate] = useState({
    startTime: "",
    endTime: "",
  });

  const [secondAPi, setsecondAPi] = useState(false);

  const [filter, setFilter] = useState({
    approveType: 0,
    type: null,
    hideShow: false,
  });

  const selectedTime = useSelector(
    (state) => state.dashboardReducer.timeSeries
  );
  useEffect(() => {
    if (selectedTime != undefined || null || "") {
      setDate({
        ...date,
        startTime: selectedTime.start,
        endTime: selectedTime.end,
      });
    }
  }, [selectedTime]);

  console.log({ selectedTime });

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);

  const onChangeTe = useAsyncDebounce((e) => {
    settotalPageCountShow(e || 1);
    settotalPageCount(e - 1 || 0);
    console.log(e, "hello ji");
  }, 10);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);

  const approveUserModal = async (cell) => {
    await setSelectedUserDetailApprove(cell?.row?.original);
    await modelButtonApprove.current.click();
  };

  const rejectUserModal = async (cell) => {
    console.log(cell.row.original);

    await setSelectedUserDetail(cell.row.original);
    await modelButtonReject.current.click();
  };

  console.log({ selectedUserDetailApprove });

  const columns = useMemo(
    () => [
      {
        Header: "Camp ID",

        accessor: "id", // accessor is the "key" in the data
        Cell: (row, index) => {
          //     console.log(row, "helloo");
          return <>{row.row.index + 1}</>;
        },
      },
      {
        Header: "Voice Prompt",

        accessor: "voicePrompt", // accessor is the "key" in the data
        // Cell: (cell) => {
        //   return <>{new Date()}</>;
        // },
      },
      {
        Header: "Info",

        accessor: "info", // accessor is the "key" in the data
        Cell: (cell, row, index) => {
          return (
            <>
              {
                <Tooltip
                  onClick={() => {
                    approveUserModal(cell);
                  }}
                  style={{ cursor: "pointer" }}
                  placement="top"
                  title={` Info of ${cell.row.original.voicePrompt}`}
                >
                  <InfoIcon />
                </Tooltip>
              }
            </>
          );
        },
      },
      {
        Header: "Caller-ID",

        accessor: "senderId", // accessor is the "key" in the data
        // Cell: (cell) => {
        //   return <>{new Date()}</>;
        // },
      },

      {
        Header: "Date",

        accessor: "datetimeEntry", // accessor is the "key" in the data
        Cell: (cell) => {
          return <>{dateFormatter(cell.row.original.datetimeEntry)}</>;
        },
      },
      {
        Header: "Scheduled Date",

        accessor: "datetimeSecheduled", // accessor is the "key" in the data
        Cell: (cell) => {
          return <>{dateFormatter(cell.row.original.datetimeSecheduled)}</>;
        },
      },
      {
        Header: "End Date",

        accessor: "datetimeEnd", // accessor is the "key" in the data
        Cell: (cell) => {
          return <>{dateFormatter(cell.row.original.datetimeEnd)}</>;
        },
      },
      {
        Header: "Camp Name",

        accessor: "eventName", // accessor is the "key" in the data
      },

      {
        Header: "Status",

        accessor: "status",
        Cell: (cell) => {
          return (
            <>
              {cell.row.original.approved == 0 ? (
                <div className="badge badge_8 bg-warning">Pending</div>
              ) : cell.row.original.approved == "completed" ? (
                <div className="badge badge_8 bg-success">Complete</div>
              ) : (
                <div className="badge badge_8 bg-success">Complete</div>
              )}
            </>
          );
        },
      },

      {
        Header: "View",

        accessor: "download",
        Cell: (cell) => {
          return (
            <>
              <IconButton
                onClick={() => {
                  excelExport(cell);
                }}
                variant="text"
                size="small"
                sx={{ fontSize: "5px" }}
                aria-describedby={
                  Boolean(anchorEll) ? "simple-popover" : undefined
                }
              >
                <DownloadIcon style={{ color: "black" }} />
              </IconButton>
            </>
          );
        },
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    console.log({ selectedFlatRows });
  };

  const customId1 = "custom-id-yes";

  const NextPage = () => {
    settotalPageCount(totalPageCount + 1);
    settotalPageCountShow(totalPageCount + 2);
  };

  const PreviousPage = () => {
    settotalPageCount(totalPageCount - 1);
    settotalPageCountShow(totalPageCount);
  };

  console.log(date.start);
  useEffect(() => {
    if (totalPageCount > totalPage) {
      settotalPageCount(1);
    }
  }, [totalPageCount]);

  const paginationData = async () => {
    if (totalPageCount <= 0 || totalPageCount != -1) {
      try {
        setOpen(true);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_REPORTS}/user-voice/v1/voice-campagin/get/campaign-report`,
          {
            pageNo: totalPageCount == -1 ? 0 : totalPageCount,

            pageSize: pageSize,
          }
        );
        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          setData(res.data?.campaignCreation?.content);
          // setDownloadedData(res.data?.campaignCreation?.content);

          await setTotalPage(res?.data?.campaignCreation?.totalPages);
          await settotalPageCount(res?.data?.campaignCreation?.number);
        } else {
          setOpen(false);
          Swal.fire({
            icon: "error",
            //  title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } catch (error) {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    }
  };

  // console.log({ downloadeddata });

  const filterdata = async () => {
    // settotalPageCount(0);
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_REPORTS}/user-voice/v1/voice-campagin/get/campaign-report/by/datetimeSecheduled`,
        {
          sechduleDateTime: moment(date.startTime).format("YYYY-DD-MM"),
          endSechduleDateTime: moment(date.endTime).format("YYYY-DD-MM"),
          pageNo: totalPageCount == -1 ? 0 : totalPageCount,
          pageSize: pageSize,
        }
      );
      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);

        setData(res.data.campaignCreation.content);
        await setTotalPage(res?.data?.campaignCreation?.totalPages);
        // await settotalPageCount(res?.data?.campaignCreation?.number);
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          //  title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const filterdata1 = async () => {
    // settotalPageCount(0);
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_REPORTS}/user-voice/v1/voice-campagin/get/campaign-report/by/datetimeSecheduled`,
        {
          sechduleDateTime: moment(date.startTime).format("YYYY-DD-MM"),
          endSechduleDateTime: moment(date.endTime).format("YYYY-DD-MM"),
          pageNo: totalPageCount == -1 ? 0 : totalPageCount,
          pageSize: pageSize,
        }
      );
      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        await settotalPageCount(0);
        await settotalPageCountShow(1);

        setData(res.data.campaignCreation.content);
        await setTotalPage(res?.data?.campaignCreation?.totalPages);
        // await settotalPageCount(res?.data?.campaignCreation?.number);
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          //  title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  console.log({ secondAPi });
  useEffect(async () => {
    if (secondAPi == true) {
      filterdata();
      // settotalPageCount(1);
    } else {
      paginationData();
    }
  }, [pageSize, totalPageCount]);

  // useEffect(() => {
  //   if (date.start != undefined && secondAPi == true) {
  //     alert("n");
  //     filterdata();
  //   }
  // }, [date.start]);

  const excelExport = async (cell) => {
    console.log({ cell });
    try {
      setOpen(true);
      const res = await common_axios(
        `${process.env.REACT_APP_COMMON_API_REPORTS}/user-voice/export/voice-campaign/campaign-dst/excel?queue_id=${cell?.row?.original?.id}`,

        {
          responseType: "arraybuffer",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(res.data);
      await setOpen(false);
      const filename = cell?.row?.original?.id;
      const filenamee = dateFormatter(cell?.row?.original?.datetimeEntry);
      console.log({ filename });
      const url = window.URL.createObjectURL(new Blob([res.data])); // you can mention a type if you wish
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${filename}_${filenamee}.xlsx`); //this is the name with which the file will be downloaded
      // link.setAttribute("download", `${filename}`.xlsx); //this is the name with which the file will be downloaded
      link.click();
      // no need to append link as child to body.
      setTimeout(() => window.URL.revokeObjectURL(url), 0); // this is important too, otherwise we will be unnecessarily spiking memory!
    } catch (error) {
      console.log(error);
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      {selectedUserDetailApprove != undefined && (
        <>
          <button
            type="button"
            ref={modelButtonApprove}
            class="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            Launch static backdrop modal
          </button>

          <form>
            <div
              class="modal fade"
              id="staticBackdrop"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">
                      Prompt Information
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <div className="row">
                      <div className="col-md-6 mt-3">
                        <label for="exampleInputEmail1" className="form-label">
                          Cmapaign ID:
                        </label>
                        <input
                          type="text"
                          disabled
                          value={selectedUserDetailApprove?.id}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label for="exampleInputEmail1" className="form-label">
                          Caller Id :
                        </label>
                        <input
                          type="text"
                          disabled
                          value={selectedUserDetailApprove?.senderId}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mt-3">
                        <label for="exampleInputEmail1" className="form-label">
                          Campaign Name
                        </label>
                        <input
                          type="text"
                          disabled
                          value={
                            selectedUserDetailApprove?.eventName || "-------"
                          }
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                      <div className="col-md-6 mt-3">
                        <label for="exampleInputEmail1" className="form-label">
                          Queue Code
                        </label>
                        <input
                          type="text"
                          disabled
                          value={
                            selectedUserDetailApprove?.queueCode || "-------"
                          }
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                      <div className="col-md-6 mt-3">
                        <label
                          for="exampleInputEmail1"
                          className="form-label me-2"
                        >
                          Status
                        </label>
                        {selectedUserDetailApprove?.approvalStatus == 1 ? (
                          <>
                            <div className="badge badge_8 bg-success">
                              Approved
                            </div>
                          </>
                        ) : selectedUserDetailApprove?.approvalStatus == 2 ? (
                          <>
                            <>
                              <div className="badge badge_8 bg-danger">
                                Rejected
                              </div>
                            </>
                          </>
                        ) : (
                          <>
                            <div className="badge badge_8 bg-warning">
                              Pending
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </>
      )}

      <div className="container-fluid">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <div className="card mb-3 mt-4">
          <div className="card-header p-3 pt-2">
            <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
              <ReceiptIcon style={{ fontStyle: "30px", color: "white" }} />
            </div>
            <div className="pt-1">
              <p
                className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
                style={{ marginLeft: "70px" }}
              >
                Scheduled Voice Campaign Reports
              </p>
            </div>
          </div>

          {/* {data.length > 0 ? ( */}
          <>
            <div className="d-flex flex-wrap justify-content-between my-3">
              {/* {filter.hideShow && (
                  <>
                    <div className="d-flex">
                      <div
                        className="d-flex justify-content-between mx-3"
                        style={{ width: "300px" }}
                      >
                        <FormControl fullWidth>
                          <InputLabel size="small" id="test-select-label">
                            Select Type
                          </InputLabel>
                          <Select
                            size="small"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={Status.type}
                            label="Select Type"
                            onChange={(e) => {
                              setFilter({
                                ...filter,
                                type: e.target.value,
                              });
                            }}
                          >
                            {[
                              { id: 0, name: "All", value: null },
                              {
                                id: 1,
                                name: "Promotional",
                                value: "Promotional",
                              },
                              {
                                id: 2,
                                name: "Transactional",
                                value: "Transactional",
                              },
                            ].map((d) => {
                              return (
                                <MenuItem value={d.value}> {d.name}</MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </div>

                      <div className="d-flex justify-content-between">
                        <button
                          disabled={filter.type == null}
                          onClick={fetchUser}
                          className={
                            filter.type == null
                              ? "btn btn-secondary"
                              : "btn btn-primary"
                          }
                        >
                          Filter
                        </button>
                      </div>
                    </div>
                  </>
                )} */}
            </div>

            <div className="card-body">
              <div className="card shadow-none border bg_blue">
                <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                  Select Date
                </span>
                <p className="text-sm mb-0  text-capitalize d-inline-block float-end text-end me-3 fw-bold">
                  Note: By Default Dates are for Current Week
                  <span className="ms-2 text-danger fw-bold">*</span>
                </p>

                <div className="card-body text-lg-start text-center">
                  <>
                    <div className="row">
                      <div className="col-md-2">
                        <TextField
                          disabled
                          className="w-100"
                          label="Reports From"
                          name="userName"
                          variant="outlined"
                          size="small"
                          type="text"
                          value={selectedTime.start}
                          onClick={(event) => {
                            setAnchorEll(event.currentTarget);
                          }}
                        />
                      </div>
                      <div className="col-md-1">
                        <div className="text-center ">
                          {/* <ForwardIcon /> */}
                          <PanToolAltIcon
                            // className="icon_rotation"
                            style={{
                              transform: "rotate(90deg)",
                            }}
                            // style={{ tranform: "rotate(90deg)" }}
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <TextField
                          disabled
                          className="w-100"
                          label="Reports To"
                          name="userName"
                          variant="outlined"
                          size="small"
                          type="text"
                          value={selectedTime.end}
                          onClick={(event) => {
                            setAnchorEll(event.currentTarget);
                          }}
                        />
                      </div>
                      <div className="col-md-2 ms-4">
                        <IconButton
                          variant="text"
                          size="small"
                          // size="medium"
                          sx={{
                            color: "#7B809A",
                          }}
                          aria-describedby={
                            Boolean(anchorEll) ? "simple-popover" : undefined
                          }
                          onClick={(event) => {
                            setAnchorEll(event.currentTarget);
                          }}
                        >
                          <CalendarMonthIcon
                            sx={{ color: "black", fontSize: "30px" }}
                          />
                        </IconButton>
                        <Popover
                          id={Boolean(anchorEll) ? "simple-popover" : undefined}
                          open={Boolean(anchorEll)}
                          anchorEl={anchorEll}
                          onClose={() => {
                            setAnchorEll(null);
                          }}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                          }}
                        >
                          <DateRangePickerr className="btn bg-gradient-primary m-0" />
                        </Popover>

                        <Button
                          className="ms-2"
                          variant="contained"
                          onClick={() => {
                            filterdata1();
                            // settotalPageCount(1);
                            setsecondAPi(true);
                          }}
                          endIcon={<SearchIcon />}
                        >
                          Search
                        </Button>
                      </div>
                      <div className="text-end">
                        <CSVLink data={data}>
                          <Button
                            sx={{ borderRadius: "10px", fontSize: "10px" }}
                            startIcon={<CloudDownloadIcon />}
                            variant="outlined"
                            className="btn bg-gradient-primary m-0"
                          >
                            {" "}
                            To Excel
                          </Button>
                        </CSVLink>
                      </div>
                    </div>
                  </>
                </div>
              </div>

              <div className="text-end mt-5" style={{ flexGrow: "1" }}>
                <IconButton
                  variant="text"
                  size="small"
                  sx={{
                    color: "#7B809A",
                  }}
                  onClick={(event) => {
                    setFilter({
                      ...filter,
                      hideShow: !filter.hideShow,
                    });
                  }}
                >
                  {filter.hideShow ? <CancelIcon /> : <SearchIcon />}
                </IconButton>
              </div>
              {filter.hideShow && (
                <div className="d-flex justify-content-between my-3">
                  <select
                    value={pageSize}
                    className="dropdown"
                    onChange={(e) => {
                      setPageSize(Number(e.target.value));
                    }}
                  >
                    {[10, 25, 50].map((value, i) => {
                      return (
                        <option
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                          value={value}
                          key={value}
                        >
                          Show {value}
                        </option>
                      );
                    })}
                  </select>

                  <div className="d-flex align-items-center">
                    <TextField
                      className="ms-4"
                      style={{
                        borderRadius: "4px",
                      }}
                      type="text"
                      label="Search"
                      name="Search"
                      variant="outlined"
                      // value={number}
                      size="small"
                      value={globalSearchValue || ""}
                      onChange={(e) => {
                        onChange(e.target.value);
                        setGlobalSearchValue(e.target.value);
                      }}
                    />
                  </div>
                </div>
              )}

              <div className="text-end">
                {selectedFlatRows.length > 0 && (
                  <button
                    onClick={deletUser}
                    className="btn bg-gradient-primary m-0"
                  >
                    Delete Users
                  </button>
                )}
              </div>
              {data.length > 0 ? (
                <>
                  <div className="table-responsive">
                    <table
                      {...getTableProps()}
                      id="example"
                      className="table table-striped table-bordered dataTable table-sm mt-3"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        {headerGroups.map((headerGroup) => (
                          <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                              <th
                                {...column.getHeaderProps(
                                  column.getSortByToggleProps()
                                )}
                                className="text-center width_2"
                              >
                                {column.render("Header")}
                                <span>
                                  {column.isSorted
                                    ? column.isSortedDesc
                                      ? "↑"
                                      : "↓"
                                    : ""}
                                </span>
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <tr {...row.getRowProps()}>
                              {row.cells.map((cell) => {
                                return (
                                  <td
                                    {...cell.getCellProps()}
                                    className="text-left"
                                  >
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div>
                      <span>
                        Page:
                        <strong>
                          {/* {secondAPi == true ? (
                            <>
                              {totalPageCount + 1} of {totalPage}
                            </>
                          ) : (
                            <>
                              {totalPageCount + 1} of {totalPage}
                            </>
                          )} */}
                          {totalPageCount == -1 || 0 ? (
                            <>1 of {totalPage}</>
                          ) : (
                            <>
                              {totalPageCount + 1} of {totalPage}
                            </>
                          )}
                        </strong>
                      </span>
                    </div>

                    <div>
                      <span>
                        Go to Page :{""}
                        <input
                          type="number"
                          min={1}
                          max={totalPage}
                          value={Number(totalPageCountShow)}
                          onChange={(e) => {
                            console.log("EEEEE", e.target.value);

                            if (e.target.value > totalPage) {
                              settotalPageCountShow(totalPage);
                              settotalPageCount(totalPage - 1);
                            } else if (totalPageCount == -1) {
                              settotalPageCount(0);
                            } else {
                              onChangeTe(e.target.value);
                            }
                          }}
                          style={{ width: "50px" }}
                        />
                      </span>
                    </div>

                    <div id="Nikhil">
                      <button
                        className="btn btn_primary m-0 ms-2"
                        type="button"
                        style={{
                          background: "#2C97D4",
                        }}
                        // disabled={!canPreviousPage}
                        disabled={totalPageCount == 0}
                        onClick={() => {
                          previousPage();
                          PreviousPage();
                        }}
                      >
                        Prev
                      </button>

                      <button
                        className="btn btn_primary m-0 ms-2"
                        type="button"
                        style={{
                          background: "#2C97D4",
                        }}
                        disabled={totalPageCount + 1 == totalPage}
                        onClick={() => {
                          nextPage();
                          NextPage();
                        }}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <h2 className="text-center">No Data Avalaible</h2>
                </>
              )}
            </div>
          </>
        </div>
      </div>
    </main>
  );
}
